import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ToastAppearanceValue } from '@vw-marketing/us-components';

interface ToastContextType {
  toast: boolean;
  toastTitle: string;
  toastMessage: string | React.JSX.Element[];
  toastAppearance: ToastAppearanceValue;
  showToast: (
    message: string | React.JSX.Element[],
    appearance?: ToastAppearanceValue,
    title?: string,
  ) => void;
  hideToast: () => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [toast, setToast] = useState<boolean>(false);
  const [toastTitle, setToastTitle] = useState<string>('');
  const [toastMessage, setToastMessage] = useState<
    string | React.JSX.Element[]
  >('');
  const [toastAppearance, setToastAppearance] =
    useState<ToastAppearanceValue>('Success');
  const hideToast = () => {
    setToast(false);
  };

  const showToast = (
    message: string | React.JSX.Element[],
    appearance: ToastAppearanceValue = 'Success',
    title: string = '',
  ) => {
    setToastMessage(message);
    setToastAppearance(appearance);
    setToastTitle(title);
    setToast(true);
  };

  return (
    <ToastContext.Provider
      value={{
        toast,
        toastTitle,
        toastMessage,
        toastAppearance,
        showToast,
        hideToast,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
